import { initializeChart } from "~/recipal-app/controllers/shared/transactions_chart";
import { onViewLoad } from "~/jose_modern/on_view_load";

onViewLoad("finished_goods#history", () => {
  initializeChart("finished-good-transactions-chart");
});
